module.exports = __webpack_public_path__ + "static/Moka-df0e0dd8b2bfa6f334777ce79bb6031c.svg";